import * as api from "../services/turgoil-api";

export function getStatistics() {
  return api.getLandingPageStatistics().then((count) => {
    return count;
  });
}
